export default "__VITE_ASSET__DMmSOkEb__"